var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconEvent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M6 1h7V0h2v1h1.522C17.934 1 19 2.02 19 3.478v14.044C19 18.98 17.934 20 16.522 20H2.478C1.066 20 0 18.98 0 17.522V3.478C0 2.02 1.066 1 2.478 1H4V0h2zM2 5v13h15V5zm5.925 10.438-3.627-3.626a1.019 1.019 0 1 1 1.44-1.44l2.54 2.35 4.983-4.795a1.019 1.019 0 0 1 1.44 1.44l-6.069 6.07a.5.5 0 0 1-.707.001"
})));
export default SvgIconEvent;